import { tap, finalize } from 'rxjs';
import { BrandInterface, BrandApiService } from '@/app/features/brand';

import { signal, Injectable, WritableSignal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class BrandStore {
  public brand: WritableSignal<BrandInterface | undefined> = signal(undefined);

  public isLoading: WritableSignal<boolean> = signal(false);

  constructor(private apiService: BrandApiService) {}

  public loadBrand() {
    this.isLoading.set(true);

    return this.apiService.loadBrand().pipe(
      tap((response) => {
        this.brand.set(response.payload.content);
      }),
      finalize(() => this.isLoading.set(false)),
    );
  }
}
